import Meta from '#/components/Meta/meta'
import Alert from './alert'

interface LayoutProps {
  preview: boolean
  meta: Blog.Meta
  children?: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ preview, children, meta }) => (
  <>
    <Meta meta={meta} />
    <div className='min-h-screen'>
      {preview && <Alert preview={preview} />}
      <main>{children}</main>
    </div>
  </>
)

export default Layout
